import { useMemo } from 'react'

const defaultOptions = {
  //   style: 'currency',
  //   currency: 'USD',
  //   symbol: '$d',
  //   code: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  currencySign: 'accounting',
  addParanthesesForNegative: true,
  //   currencyDisplay: 'none',
}

export default function useNumberFormatter(options = {}) {
  const combinedOptions = useMemo(
    () => ({
      ...defaultOptions,
      ...options,
    }),
    [options],
  )

  const formatter = useMemo(() => {
    return new Intl.NumberFormat(undefined, { ...combinedOptions })
  }, [combinedOptions])

  const formatNumber = (value) => {
    const formattedValue = formatter.format(value)
    if (value < 0 && combinedOptions.addParanthesesForNegative) {
      return `(${formattedValue})`
    }
    return formattedValue
  }

  return formatNumber
}
